import PropTypes from "prop-types"

const RiskOfLeavingBarShape = {
  reviewName: PropTypes.string,
  reviewDateCreated: PropTypes.string,
  lowCount: PropTypes.number,
  mediumCount: PropTypes.number,
  highCount: PropTypes.number,
}
export default RiskOfLeavingBarShape



// WEBPACK FOOTER //
// ./src/state/shapes/RiskOfLeavingBarShape.js